var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"send 2\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3685 1.72579L6.35246 3.74922C-0.381631 5.12158 -0.690308 8.13988 5.6661 10.4606L8.47273 11.4835L9.18238 13.9975C10.7943 19.6918 14.374 19.9536 17.1181 14.5779L21.2047 6.59029C23.0272 3.00292 20.8612 0.81419 16.3685 1.72579ZM16.2118 6.65686L11.7583 9.84052C11.5826 9.96546 11.3712 10.0143 11.1664 9.99933C10.9615 9.98434 10.7632 9.90553 10.6154 9.75692C10.3298 9.4696 10.3746 9.03191 10.7143 8.79034L15.1678 5.60669C15.5075 5.36512 16.025 5.40297 16.3107 5.69029C16.5963 5.9776 16.5515 6.41529 16.2118 6.65686Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIconSend);
export default __webpack_public_path__ + "static/media/white-icon-send.a1932ff7ce008123a475c76ffce41770.svg";
export { ForwardRef as ReactComponent };